import React, { useContext, useState } from 'react';

import { Trans } from 'react-i18next';
import { DirectionContext } from '../Contexts/DirectionContext';
import { Link, useNavigate } from 'react-router-dom';
import { contentData } from './FullBlogs';
import { useBlog } from '../Contexts/BlogContext';


export default function MoreBlogs() {
  const { currentBlogId, setCurrentBlog } = useBlog();
  const { dir } = useContext(DirectionContext);
  const navigate = useNavigate();
  const TitleStyle = {
    borderRight: dir === 'rtl' ? '6px solid' : 'none',
    borderLeft: dir === 'ltr' ? '6px solid' : 'none',
  };

  const filteredBlogs = contentData.filter(blog => blog.id !== currentBlogId);


  const handleViewFullBlog = (id) => {
    const blog = contentData.find(b => b.id === id);
    const content = contentData.find(c => c.id === id);
    setCurrentBlog(id); 
    console.log(currentBlogId)

    navigate(`/info/FullBlog/${id}`, {
      state: {
        blogData: blog,
        contentData: content
      }
    });
  };

  return <>
        <div className="col-md-11">
          <h2 className="Title px-2 my-5" >
            <Trans i18nKey="MoreBlogsTitle">مزيد من المقالات</Trans>
          </h2>
        </div>

        <div className="container-fluid">
          <div className="row g-4 px-2">
            {filteredBlogs.map((blog, index) => (
              <div key={index} className="col-md-6 col-lg-4   wow fadeInLeft" data-wow-delay=".3s">
                <div className="Related-Blogs-card p-4">
                  <div
                    className={`card-img-top ${blog.imageClass}`}
                    style={{
                      backgroundSize: 'cover',
                      backgroundPosition: 'center',
                      height: '220px',
                      borderRadius: '4px',
                    }}
                  ></div>

                  <div className="card-body">
                    <h3 className="card-title mt-4">{dir == 'ltr' ? blog.title_en : blog.title}</h3>
                    <div className="Line mt-2 mb-4"></div>

                    <div className="row DateTime">
                      <div className="col-auto">
                        <p>{dir == 'ltr' ? blog.date_en : blog.date}</p>
                      </div>
                      <div className="col-auto p-0">
                        <i className="bi bi-three-dots-vertical"></i>
                      </div>
                      <div className="col-auto ">
                        <p>{dir == 'ltr' ? blog.readTime_en : blog.readTime}</p>
                      </div>
                    </div>

                    <p className="MoreBlogP clamped-text">{dir == 'ltr' ? blog.brief_en : blog.brief}</p>
                    <Link
                        onClick={(e) => {
                          e.preventDefault();
                          handleViewFullBlog(blog.id);
                        }}
                        style={{ textDecoration: 'none', color: 'white' }}
                      >
                    <button className="ReadMoreAnchor p-3" >
                      
                        <Trans i18nKey="ContinueReadingBtn">تابع القراءة</Trans>
                     
                      <i
                        className={
                          dir === 'ltr'
                            ? 'fa-solid fa-chevron-right px-2'
                            : 'fa-solid fa-chevron-left px-2'
                        }
                      ></i>
                    </button>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
  </>
}
